module.exports = __webpack_public_path__ + "img/maintenance.d722acc.png";